import { Component, OnInit, ViewChild } from '@angular/core';
import {
  formatDate,
  MbscCalendarEvent,
  MbscEventcalendarOptions,
  MbscEventcalendarView,
  MbscPopup,
  MbscPopupOptions,
} from '@mobiscroll/angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { SLOT_CONFIG } from 'src/app/config/calendar.config';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

declare var jQuery: any;

@Component({
  selector: 'app-availability',
  templateUrl: './availability.component.html',
  styleUrls: ['./availability.component.scss'],
})
export class AvailabilityComponent implements OnInit {
  @ViewChild('popup', { static: false })
  popup!: MbscPopup;
  shiftNotes: string | undefined;
  shiftDate: any;
  tempShift!: MbscCalendarEvent;
  minTime = '';
  maxTime = '';
  popupHeader!: string;
  shiftLength!: number;
  diagnosticianId: any;
  diagnosticianName: any;

  ////////////////////////////
  // POP UP FUNCTIONS
  ////////////////////////////

  popupEditButtons = [
    'cancel',
    {
      handler: () => {
        this.deleteShift(this.tempShift);
        this.popup.close();
      },
      keyCode: 'enter',
      text: 'Delete',
      cssClass: 'btn btn-danger',
    },
  ];

  popupButtons: any = [];

  popupOptions: MbscPopupOptions = {
    display: 'bottom',
    contentPadding: false,
    fullScreen: true,
    onClose: () => {
      if (!this.isEdit) {
        this.diagnoShifts = [...this.diagnoShifts];
      }
    },
    responsive: {
      medium: {
        display: 'center',
        width: 250,
        fullScreen: false,
        touchUi: false,
        showOverlay: true,
        closeOnOverlayClick: false,
        closeOnEsc: false,
      },
    },
  };

  isEdit = false;
  diagnosticians: any;
  locations: any;
  selectedLocation: any;
  locationId: any = '';
  selectedStatus: any = '';
  userRole: any;
  popupHeaderText!: string;
  diagnoLocationId: any;
  isSaved: boolean = false;
  constructor(
    private auth: AuthenticationService,
    private appointmentService: AppointmentService,
    private spinner: NgxSpinnerService
  ) {}

  resource: any[] = [];
  appointments: any;

  // DIAGNO TIMELINE
  diagnoView: MbscEventcalendarView = {
    timeline: {
      type: 'week',
      eventList: true,
      // startDay: 1,
      // endDay: 5,
    },
  };

  slots = [
    {
      id: 1,
      name: 'Morning',
      startTime: SLOT_CONFIG.slot1.start.timeShort,
      endTime: SLOT_CONFIG.slot1.end.timeShort,
    },
    {
      id: 2,
      name: 'Afternoon',
      startTime: SLOT_CONFIG.slot2.start.timeShort,
      endTime: SLOT_CONFIG.slot2.end.timeShort,
    },
  ];
  i = 0;
  diagnoShifts: MbscCalendarEvent[] = [];

  diagnoTimelineOptions: MbscEventcalendarOptions = {
    min: new Date(), // set the minimum date to today
    onEventCreated: (args: any) => {
      setTimeout(() => {
        jQuery('body').addClass('timeline-event-created');
        jQuery('#diagnoSetAvailabilitySubmit').addClass('green');
        jQuery('#diagnoSetAvailabilitySubmit').removeClass(
          'grey pointer-disable'
        );
        jQuery('#diagnoSetAvailabilityClose').removeClass('pointer-disable');
        const shift: any = args.event;
        const start: any = shift.start;
        const slot: any = this.slots.find((s) => s.id === shift.slot);
        this.tempShift = args.event;
        this.addShift(this.tempShift);
      });
    },
    onEventClick: (args: any) => {
      jQuery('body').addClass('timeline-event-created');
      jQuery('#diagnoSetAvailabilitySubmit').addClass('green');
      jQuery('#diagnoSetAvailabilitySubmit').removeClass(
        'grey pointer-disable'
      );
      jQuery('#diagnoSetAvailabilityClose').removeClass('pointer-disable');
      const shift: any = args;
      const slot: any = this.slots.find((s) => s.id === shift.slot);
      this.isEdit = true;
      this.tempShift = args.event;

      // set popup options
      this.popupButtons = this.popupEditButtons;
      this.popupHeader =
        formatDate('MM/DD/YYYY', new Date(shift.date)) +
        '<br>' +
        slot.name +
        ' Shift';

      this.popup.open();
    },
    onEventDeleted: (args) => {
      this.deleteShift(args.event);
    },

    clickToCreate: 'single',
    dragToMove: false,
    dragToCreate: false,
    dragToResize: false,
    view: {
      timeline: {
        type: 'week',
        allDay: false,
        // startDay: 1,
        // endDay: 5
      },
    },

    slots: this.slots,
  };
  invalid: any = [];
  show: boolean = false;

  // Location Select
  shifts: any;
  ngOnInit(): void {
    this.show = false;
    this.spinner.show();
    this.invalid = [];
    this.diagnoLocationId = this.auth.getUserLocationId();
    let diagno = {
      name: this.auth.getUserFullName(),
      id: this.auth.getUserId(),
    };
    this.userRole = this.auth.getUserType();
    let userType = 1002;

    this.resource.push(diagno);

    this.appointmentService
      .getOriginalDiagUnavailability(this.auth.getUserId(), null, userType)
      .subscribe((res) => {
        this.shifts = res;
        this.diagnoShifts = this.shifts.data;
        this.shiftLength = this.diagnoShifts.length;

        this.appointmentService
          .getAppointments(
            this.diagnoLocationId,
            this.auth.getUserId(),
            'ALL',
            null,
            null,
            null
          )
          .subscribe((res) => {
            this.appointments = res.data;
            if (this.appointments.length == 0) {
              this.spinner.hide();
              this.show = true;
            } else {
              this.appointments.forEach((element: any) => {
                element.appointmentDetails.schedules.forEach((appt: any) => {
                  if (appt.status != 'CANCEL' && appt.status != 'FOLLOWUP') {
                    let invalidDate = {
                      start: appt.start,
                      end: appt.end,
                      resource: appt.resource,
                      slot: appt.slot,
                      title: 'Appointed',
                      locationId: this.diagnoLocationId,
                    };
                    this.invalid.push(invalidDate);
                  }
                });
                this.spinner.hide();
                this.show = true;
              });
            }
          });
      });
  }

  deleteShift(shift: MbscCalendarEvent): void {
    // if(this.isSaved){
    let ed = shift.end;
    var endDate = new Date(ed as Date);
    var userTimezoneOffset = endDate.getTimezoneOffset() * 60000;
    endDate = new Date(endDate.getTime() - userTimezoneOffset);
    shift.end = endDate + '';

    this.diagnoShifts = this.diagnoShifts.filter(
      (item) => item.end != shift.end
    );
    if (this.diagnoShifts.length == this.shiftLength) {
      jQuery('body').removeClass('timeline-event-created');
      jQuery('#diagnoSetAvailabilitySubmit').removeClass('green');
      jQuery('#diagnoSetAvailabilitySubmit').addClass('grey pointer-disable');
      jQuery('#diagnoSetAvailabilityClose').addClass('pointer-disable');
    }
  }

  addShift(shift: MbscCalendarEvent) {
    let sd = shift.start;
    let ed = shift.end;
    var startDate = new Date(sd as Date);
    var userTimezoneOffset = startDate.getTimezoneOffset() * 60000;
    startDate = new Date(startDate.getTime() - userTimezoneOffset);

    var endDate = new Date(ed as Date);
    var userTimezoneOffset = endDate.getTimezoneOffset() * 60000;
    endDate = new Date(endDate.getTime() - userTimezoneOffset);

    let s = {
      end: endDate,
      resource: shift.resource,
      slot: shift.slot,
      start: startDate,
      title: 'Available',
      locationId: this.diagnoLocationId,
    };

    this.diagnoShifts.push(s);
  }
  closeShift() {
    this.isSaved = true;
    jQuery('body').removeClass('timeline-event-created');
    jQuery('#diagnoSetAvailabilityClose').addClass('pointer-disable');
  }
  saveShift() {
    this.isSaved = true;
    jQuery('body').removeClass('timeline-event-created');
    jQuery('#diagnoSetAvailabilitySubmit').removeClass('green');
    jQuery('#diagnoSetAvailabilitySubmit').addClass('grey pointer-disable');
    this.appointmentService
      .setDiagnosticianUnavailability(this.diagnoShifts)
      .subscribe((res) => {});
  }

  defaultShift(args: any): any {
    const d = args.start;
    const start = new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      args.slot === 1
        ? SLOT_CONFIG.slot1.start.hour
        : SLOT_CONFIG.slot2.start.hour
    );
    const end = new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      args.slot === 1 ? SLOT_CONFIG.slot1.end.hour : SLOT_CONFIG.slot2.end.hour
    );

    return {
      title: 'Available',
      start,
      end,
      resource: args.resource,
    };
  }
}
